module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_37.ff7ceda4.png";